import { clientFetch } from '../clientFetch';

export const getSpecialtyBySlug = async (specialty) => clientFetch(`/lookup/specialty`, { params: { specialty } });
